<div class="modal-header">
  <div class="modal-title-wrapper">
    <h2 class="modal-title fw-bold">{{ eventClass.class_name }}</h2>
    <div class="class-meta d-flex gap-4 mt-2">
      @if (eventClass.start_date_time) {
        <span class="text-muted">
          <i class="fa fa-calendar me-2"></i>
          {{ formatDateDMYDots(eventClass.start_date_time) }}
        </span>
      }
      @if (eventClass.price) {
        <span class="text-muted">
          <i class="fa fa-money-bill me-2"></i>
          {{ eventClass.price }} {{ eventClass.price_currency }}
        </span>
      }
      <span class="text-muted">
        <i class="fa fa-users me-2"></i>
        {{ eventClass.event_class_registrations.length }} Registration{{ eventClass.event_class_registrations.length !== 1 ? 's' : '' }}
      </span>
    </div>
  </div>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  @if (eventClass.class_description) {
    <div class="alert alert-info d-flex align-items-center mb-6">
      <i class="fa fa-info-circle fs-2x me-3"></i>
      <div>{{ eventClass.class_description }}</div>
    </div>
  }

  @if (eventClass.event_class_registrations.length === 0) {
    <div class="text-center py-10">
      <i class="fa fa-users-slash fs-3x text-muted mb-5"></i>
      <h4 class="text-muted">No Registrations Yet</h4>
      <p class="text-muted">This class doesn't have any registrations yet.</p>
    </div>
  } @else {
    <!-- Registrations Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold">
        <thead class="fw-bold text-muted bg-light">
          <tr>
            <th class="ps-6">#</th>
            <th>Rider</th>
            <th>Horse</th>
            <th>Registered On</th>
            <th class="text-center">Score</th>
            <th class="text-end min-w-70px">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (registration of eventClass.event_class_registrations; track registration.class_registration_id; let i = $index) {
            <tr>
              <td class="ps-6 fw-semibold text-gray-700">{{ getRegistrationNumber(i) }}</td>
              <td>
                @if (registration.user) {
                  <div
                    class="d-flex flex-column cursor-pointer user-info-hover"
                    [ngbTooltip]="userTooltip"
                    placement="right"
                    container="body">
                    <span class="fw-semibold text-gray-800">
                      {{ registration.user.first_name }} {{ registration.user.last_name }}
                    </span>
                    @if (registration.user.email) {
                      <span class="text-muted fs-7">{{ registration.user.email }}</span>
                    }
                  </div>
                  <ng-template #userTooltip>
                    <div class="tooltip-content">
                      <div class="tooltip-header">Rider Information</div>
                      <div class="tooltip-row">
                        <strong>Name:</strong> {{ registration.user.first_name }} {{ registration.user.last_name }}
                      </div>
                      @if (registration.user.email) {
                        <div class="tooltip-row">
                          <strong>Email:</strong> {{ registration.user.email }}
                        </div>
                      }
                      @if (registration.user.phone) {
                        <div class="tooltip-row">
                          <strong>Phone:</strong> {{ registration.user.phone }}
                        </div>
                      }
                      @if (registration.user.date_of_birth) {
                        <div class="tooltip-row">
                          <strong>Date of Birth:</strong> {{ formatDateDMYDots(registration.user.date_of_birth) }}
                        </div>
                      }
                      @if (registration.user.city || registration.user.country) {
                        <div class="tooltip-row">
                          <strong>Location:</strong> {{ registration.user.city }}@if(registration.user.city && registration.user.country){, }{{ registration.user.country }}
                        </div>
                      }
                      @if (registration.user.riding_club) {
                        <div class="tooltip-row">
                          <strong>Riding Club:</strong> {{ registration.user.riding_club }}
                        </div>
                      }
                    </div>
                  </ng-template>
                } @else {
                  <span class="text-muted">N/A</span>
                }
              </td>
              <td>
                @if (registration.horse) {
                  <div
                    class="d-flex flex-column cursor-pointer horse-info-hover"
                    [ngbTooltip]="horseTooltip"
                    placement="right"
                    container="body">
                    <span class="fw-semibold text-gray-800">{{ registration.horse.name }}</span>
                    @if (registration.horse.breed) {
                      <span class="text-muted fs-7">{{ registration.horse.breed }}</span>
                    }
                  </div>
                  <ng-template #horseTooltip>
                    <div class="tooltip-content">
                      <div class="tooltip-header">Horse Information</div>
                      <div class="tooltip-row">
                        <strong>Name:</strong> {{ registration.horse.name }}
                      </div>
                      @if (registration.horse.breed) {
                        <div class="tooltip-row">
                          <strong>Breed:</strong> {{ registration.horse.breed }}
                        </div>
                      }
                      @if (registration.horse.color) {
                        <div class="tooltip-row">
                          <strong>Color:</strong> {{ registration.horse.color }}
                        </div>
                      }
                      @if (registration.horse.gender) {
                        <div class="tooltip-row">
                          <strong>Gender:</strong> {{ registration.horse.gender }}
                        </div>
                      }
                      @if (registration.horse.date_of_birth) {
                        <div class="tooltip-row">
                          <strong>Date of Birth:</strong> {{ formatDateDMYDots(registration.horse.date_of_birth) }}
                        </div>
                      }
                      @if (registration.horse.passport_id) {
                        <div class="tooltip-row">
                          <strong>Passport ID:</strong> {{ registration.horse.passport_id }}
                        </div>
                      }
                      @if (registration.horse.horse_registry_id) {
                        <div class="tooltip-row">
                          <strong>Registry ID:</strong> {{ registration.horse.horse_registry_id }}
                        </div>
                      }
                    </div>
                  </ng-template>
                } @else {
                  <span class="text-muted">N/A</span>
                }
              </td>
              <td>
                @if (registration.created_at) {
                  <span class="text-gray-700">{{ formatDateDMYDots(registration.created_at) }}</span>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td class="text-center">
                <span class="badge badge-light-secondary">Not scored</span>
                <!-- TODO: Add score input functionality here -->
              </td>
              <td class="text-end">
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="dropdown-item" (click)="openEditRegistrationModal(registration)">
                        <i class="far fa-edit me-2"></i>
                        Edit Registration
                      </a>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li>
                      <a class="dropdown-item text-danger" (click)="deleteRegistration(registration)">
                        <i class="far fa-trash-can me-2"></i>
                        Cancel Registration
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Summary Section -->
    <div class="separator my-6"></div>

    <div class="row g-5">
      <div class="col-md-4">
        <div class="card bg-light-primary">
          <div class="card-body p-5">
            <div class="d-flex align-items-center">
              <i class="fa fa-users fs-2x text-primary me-4"></i>
              <div>
                <div class="fs-7 text-muted">Total Registrations</div>
                <div class="fs-2 fw-bold text-gray-800">{{ eventClass.event_class_registrations.length }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (eventClass.max_num_registrations) {
        <div class="col-md-4">
          <div class="card bg-light-warning">
            <div class="card-body p-5">
              <div class="d-flex align-items-center">
                <i class="fa fa-chart-line fs-2x text-warning me-4"></i>
                <div>
                  <div class="fs-7 text-muted">Capacity</div>
                  <div class="fs-2 fw-bold text-gray-800">
                    {{ eventClass.event_class_registrations.length }} / {{ eventClass.max_num_registrations }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (eventClass.price) {
        <div class="col-md-4">
          <div class="card bg-light-success">
            <div class="card-body p-5">
              <div class="d-flex align-items-center">
                <i class="fa fa-money-bill fs-2x text-success me-4"></i>
                <div>
                  <div class="fs-7 text-muted">Total Revenue</div>
                  <div class="fs-2 fw-bold text-gray-800">
                    {{ eventClass.price * eventClass.event_class_registrations.length }} {{ eventClass.price_currency }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <app-button
    [variant]="'outline'"
    [label]="'Close'"
    (clicked)="close()"
  />
  <!-- TODO: Add export to PDF/Excel functionality -->
  <app-button
    [variant]="'primary'"
    [label]="'Export to PDF'"
    [iconClass]="'fa fa-file-pdf'"
    [disabled]="true"
  />
</div>
